module.exports = __webpack_public_path__ + "img/VP-UL_Overview.eb252e09.jpg";